import { render, staticRenderFns } from "./MemoDeal.vue?vue&type=template&id=4922c722&scoped=true&"
import script from "./MemoDeal.vue?vue&type=script&lang=js&"
export * from "./MemoDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922c722",
  null
  
)

export default component.exports